<template>
  <div class="fullscreen-card" v-show="!loading">
    <progress-bar :percentage="75"></progress-bar>

    <form class="form-horizontal">
      <uiv-tabs v-model="step.tabIndex" ref="tabs" class="tabs--hide">
        <uiv-tab title="details">
          <customer-details></customer-details>
        </uiv-tab>

        <uiv-tab title="address">
          <customer-address></customer-address>
        </uiv-tab>

        <uiv-tab title="terms">
          <supplier-terms></supplier-terms>
        </uiv-tab>

        <uiv-tab title="payment">
          <payment-details></payment-details>
        </uiv-tab>

        <uiv-tab title="confirm">
          <confirm></confirm>
        </uiv-tab>
      </uiv-tabs>
    </form>
  </div>
</template>

<script>
import CustomerDetails from "@/components/personal-details/CustomerDetails";
import CustomerAddress from "@/components/personal-details/CustomerAddress";
import SupplierTerms from "@/components/personal-details/SupplierTerms";
import PaymentDetails from "@/components/personal-details/PaymentDetails";
import Confirm from "@/components/personal-details/Confirm";

import ProgressBar from "@/components/progress/ProgressBar";
import ProgressSidebar from "@/components/progress/ProgressSidebar";
import ProgressGroup from "@/components/progress/ProgressGroup";
import ProgressGroupItems from "@/components/progress/ProgressGroupItems";
import ProgressGroupItem from "@/components/progress/ProgressGroupItem";

import PageHeader from "@/components/page-header/PageHeader";

import { mapState, mapGetters } from "vuex";

import {
  required,
  helpers,
  requiredIf,
  maxLength,
  minLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  name: "PersonalDetails",
  async mounted() {
    this.$store.commit("personal_details_customer/resetState");
    this.$store.commit("personal_details_address/resetState");
    this.$store.commit("personal_details_terms/resetState");
    this.$store.commit("personal_details_payment/resetState");
    this.$store.dispatch(
      "personal_details_questions/getQuestions",
      this.$refs.tabs.$children
    );

    this.$store.dispatch("page_loader/start", 0);
    try {
      await this.$store.dispatch("token/getToken");

      const isSwitched = await this.$store.dispatch(
        "personal_details_switch_plan/switched"
      );
      if (isSwitched) {
        return;
      }

      await this.$store.dispatch("lookups/getEmploymentStatusList");
      await this.$store.dispatch("lookups/getTitleList");

      this.$store.dispatch("lookups/getResidentialStatusList");
      this.$store.dispatch("lookups/getDirectDebitDaysList");

      await this.$store.dispatch("personal_details_switch_plan/get");
      await this.$store.dispatch("personal_details_address/getCustomerAddress");

      this.terms.gasSmartMeterInstalled = this.quote.gasSmartMeterInstalled;
      this.terms.electricitySmartMeterInstalled = true;
      this.terms.neitherSmartMeterInstalled =
        !this.terms.gasSmartMeterInstalled &&
        !this.terms.electricitySmartMeterInstalled;
      if (
        this.terms.electricitySmartMeterInstalled ||
        this.terms.gasSmartMeterInstalled
      ) {
        this.terms.agreeSmartMeterConditions = true;
      }
      this.$store.dispatch("tracing/addAction", {
        name: "Page",
        value: "Personal Details",
      });
      this.$store.dispatch("tracing/addAction", {
        name: "Action",
        value: "Viewed",
      });
      this.$store.dispatch("tracing/saveActions");
    } finally {
      this.$store.dispatch("page_loader/stop");
    }
  },
  computed: {
    ...mapState({
      step: ({ personal_details_questions }) => personal_details_questions.step,
      quote: ({ storage }) => storage.quote,
      terms: ({ personal_details_terms }) => personal_details_terms,
      loading: ({ page_loader }) => page_loader.show,
      steps: ({ personal_details_questions }) =>
        personal_details_questions.steps,
    }),
  },
  components: {
    CustomerDetails,
    CustomerAddress,
    SupplierTerms,
    PaymentDetails,
    Confirm,

    ProgressBar,
    ProgressSidebar,
    ProgressGroup,
    ProgressGroupItems,
    ProgressGroupItem,
    PageHeader,
  },
};
</script>

<style lang="scss"></style>
